import { useReactFlow } from '@xyflow/react'
import { useCallback } from 'react'

import { AiAgentV1NodeData } from '../../../converters/shared/reactFlowTypes'

/**
 * Hook for AI Agent V1 node functionality.
 * Handles agent selection from dropdown.
 */
export const useAiAgentV1Node = (id: string, data: AiAgentV1NodeData) => {
  const { updateNodeData } = useReactFlow()

  const handleAgentSelect = useCallback(
    (value: string | undefined) => {
      updateNodeData(id, {
        ...data,
        agentId: value || undefined,
      })
    },
    [id, updateNodeData, data],
  )

  return {
    agentId: data.agentId || '',
    handleAgentSelect,
    hasData: !!data.agentId,
  }
}
